export default "__VITE_ASSET__BUWrbcS4__"